import * as palette from "../palette";

import EditorBlockHandling from "../EditorBlockHandling";
import { Hover } from "react-powerplug";
import PropTypes from "prop-types";
import React from "react";
import { XIcon } from "../icons";
import testId from "../testId";

export default function Image({ block, blockProps }) {
  const imageUrl = block.getData().get("imageUrl");
  const imageAlt = block.getData().get("imageAlt");

  return (
    <EditorBlockHandling editorState={blockProps.editorState} onChange={blockProps.onChange}>
      {({ removeBlock }) => (
        <Hover>
          {({ isHover, bindHover }) =>
            blockProps.readOnly ? (
              <img
                src={imageUrl}
                alt={imageAlt}
                css={{
                  width: "100%",
                  objectFit: "cover",
                  userSelect: "none",
                }}
              />
            ) : (
              <div
                {...testId("blocks/Image/hoverContainer")}
                css={{
                  position: "relative",
                }}
                {...bindHover}
              >
                <img
                  {...testId("blocks/Image/img")}
                  src={imageUrl}
                  alt={imageAlt}
                  css={{
                    width: "100%",
                    objectFit: "cover",
                    userSelect: "none",
                  }}
                />

                <button
                  type="button"
                  {...testId("blocks/Image/removeButton")}
                  onClick={() => removeBlock(block)}
                  css={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    border: "none",
                    borderRadius: "100%",

                    display: isHover ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",

                    height: 30,
                    width: 30,
                    margin: 10,
                    padding: 10,

                    backgroundColor: palette.text,
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <XIcon />
                </button>
              </div>
            )
          }
        </Hover>
      )}
    </EditorBlockHandling>
  );
}

Image.propTypes = {
  block: PropTypes.object.isRequired,
  blockProps: PropTypes.shape({
    readOnly: PropTypes.bool.isRequired,
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
};
